import angular from 'angular';
import components from './components';

export default angular.module('noteType.scenes', [components]).name;
